var BaseViews = require('../../base');
require('./search-filters/search-filters.scss');
var SearchFilterTabs = require('./search-filters/search-filter-tabs');
var DropdownList = require('treeline-shared-components/dropdown-list/dropdown-list.js');

var SearchFilters = BaseViews.LayoutView.extend({
    _tabs: null,
    _dropdownList: null,
    template: require('./search-filters/search-filters.html'),
    className: 'fmcy-search-filters clearfix',
    regions: {
        searchFilterTabsRegion: '.fmcy-search-filter-tabs-region',
        searchFilterDropdownListRegion: '.fmcy-search-filter-dropdown-list-region'
    },
    initialize: function(options) {
        var self = this;
        this.options = _.defaults(options || {}, {
            initialFilter: 'all',
            style: 'default',
            caption: ''
        });
    },
    setFilterActive: function(model) {
        if (!this.isRendered) {
            return;
        }
        this._tabs.setFilterActive(model);
    },
    _renderSearchFilterTabs: function() {
        var self = this;
        self._tabs = new SearchFilterTabs({
            collection: self.options.collection,
            initialFilter: self.options.initialFilter,
            style: self.options.style
        });

        self._tabs.on('filter:clicked', function(selected) {
            self.trigger('filter:clicked', selected);
        });

        self.searchFilterTabsRegion.show(self._tabs);
    },
    serializeData: function () {
        return {
            options: this.options
        };
    },
    onRender: function() {
        this._renderSearchFilterTabs();
    }
});
module.exports = SearchFilters;



/** WEBPACK FOOTER **
 ** ./assets/js/common/menu/subfilters/search-filters.js
 **/